export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./gcb.vue?vue&type=template&id=5df0c392"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/gcb.vue?vue&type=template&id=5df0c392
// module id = lTJa
// module chunks = 0